import React from 'react';
import { Button, Dropdown, Icon } from 'semantic-ui-react';

class SettingsButton extends React.Component {
  state = {
    open: false
  };


  render() {
    return (
        <Dropdown fluid open={this.state.open} icon={null} trigger={<Button compact fluid size="small" color="blue" disabled={this.props.disabled} direction="left" onClick={() => this.setState({ open: !this.state.open})} ><Icon name='setting' /> Settings</Button>} >
          <Dropdown.Menu fluid>
            <Dropdown.Item>
              {this.props.children}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
    );
  }
}

export default SettingsButton;
